<template>
    <div class="app-wrapper" :data-theme="theme">
        <component :is="layout" v-if="layout">
            <router-view />
        </component>
        <!--    <router-view v-else-if="isInFrame()"></router-view>-->
        <PolicyModal
            v-if="!isInFrame()"
            @accept-policy="onAcceptPolicy"
            :is-open="isOpenPolicy"
            :is-show-close-btn="false"
        />
        <!-- <div class="fixed bottom-1 left-1 z-50 text-gray text-xs ">
      <div>
        App v. <span>{{ systemStore.getAppVersion }}</span>
      </div>
      <div>
        Api v. <span>{{ systemStore.getApiVersion }}</span>
      </div>
    </div> -->
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"
//@ts-ignore
import { setupInterceptors } from "@/axios.js"
import { theme } from "@/services/getSiteTheme"
import { useRecaptchaProvider } from "vue-recaptcha/head"
//@ts-ignore
import { useSystemStore } from "@/stores/systemStore.js"
//@ts-ignore
import { type Component, markRaw, onMounted, ref, watch } from "vue"

import { isInFrame } from "@academy/utils"

import PolicyModal from "@/components/policy/PolicyModal.vue"
import DocsLayout from "@/layouts/DocsLayout.vue"
import EmptyHeaderLayout from "@/layouts/EmptyHeaderLayout.vue"
import EmptyLayout from "@/layouts/EmptyLayout.vue"
import LoginPageLayout from "@/layouts/LoginPageLayout.vue"
import MainLayout from "@/layouts/MainLayout.vue"
import PocketHeaderLayout from "@/layouts/PocketHeaderLayout.vue"

import { useAuthStore } from "./stores/authStore"
import { useCartStore } from "./stores/cartStore"

useRecaptchaProvider()

const route = useRoute()
const layout = ref<Component | null>(isInFrame() ? MainLayout : null)
const { locale } = useI18n()
const systemStore = useSystemStore()
const isOpenPolicy = ref(false)

const lookup: Record<string, Component> = {
    PocketHeaderLayout,
    LoginPageLayout,
    MainLayout,
    EmptyHeaderLayout,
    EmptyLayout,
    DocsLayout,
}

const changeLayout = (layoutString: string) => {
    console.log(layout.value)
    // if(!isInFrame()) {
    layout.value = markRaw(lookup[layoutString])
    // }
}

const onAcceptPolicy = () => {
    localStorage.setItem("policy", String(true))
    isOpenPolicy.value = false
}

const setLocale = () => {
    const localeMemory = localStorage.getItem("locale")

    if (localeMemory) {
        locale.value = localeMemory
    }
}

watch(route, () => {
    changeLayout(route.meta.layout + "Layout")
})

const setThemeToBody = () => {
    document.body.setAttribute("data-theme", theme)
}

setLocale()
onMounted(async () => {
    setThemeToBody()
    const authStore = useAuthStore()
    const cartStore = useCartStore()

    systemStore.loadApiLivenes()
    setupInterceptors(authStore)

    const user = JSON.parse(localStorage.getItem("user") || "null")
    if (user) {
        authStore.setUser(user)
        cartStore.syncCarts()
        // await cartStore.loadCart();
    } else {
        cartStore.loadLocalCart()
        await authStore.loginMobileApp()
    }
    const isPolicyAgree = localStorage.getItem("policy")
    if (!isPolicyAgree) {
        isOpenPolicy.value = true
    }
})
</script>
